import React, { useState, useEffect } from 'react';
import { Typography, useTheme } from '@mui/material';
import {
    Grid, Card, CardHeader, CardContent, Divider, Button, Dialog, DialogTitle, DialogContent, DialogActions, Box, List, ListItem, ListItemText, Select,
    MenuItem, 
} from '@mui/material';
import { ResponsivePie } from '@nivo/pie';
import { ResponsiveBar } from '@nivo/bar';
// import { AccountCircle, VerifiedUser, Public } from '@mui/icons-material';
// import Accordion from '@mui/material/Accordion';
// import AccordionSummary from '@mui/material/AccordionSummary';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { authenticationService, get } from 'src/services';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';

import GroupsIcon from '@mui/icons-material/Groups';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import BlockIcon from '@mui/icons-material/Block';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
// import Inventory2Icon from '@mui/icons-material/Inventory2';
// import PersonOffIcon from '@mui/icons-material/PersonOff';
// import BrokenImageIcon from '@mui/icons-material/BrokenImage';
// import BuildCircleIcon from '@mui/icons-material/BuildCircle';
// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import VerifiedIcon from '@mui/icons-material/Verified';
import CancelIcon from '@mui/icons-material/Cancel';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import InventoryIcon from '@mui/icons-material/Inventory';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { getResponsiveStyles, isMobileScreen } from 'src/common/utils/responsive';


const StatCard = ({ title, value, icon, color,onClick }) => {
  const theme = useTheme();

  return (
    <Card
      onClick={onClick} 
      sx={{
        height: 120,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 2,
        background: `linear-gradient(
          135deg,
          ${theme.palette[color].light} 0%,
          rgba(255,255,255,0.08) 100%
        )`,
        border: `1px solid ${theme.palette[color].main}`,
        transition: 'all 0.25s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 6
        }
      }}
    >
      {/* LEFT TEXT */}
      <Box>
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, opacity: 0.85, color: "white" }}
        >
          {title}
        </Typography>

        <Typography
          variant="h4"
          sx={{ fontWeight: 700, mt: 0.5 }}
        >
          {value}
        </Typography>
      </Box>

      {/* RIGHT ICON */}
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette[color].main,
          color: '#fff'
        }}
      >
        {icon}
      </Box>
    </Card>
  );
};


const FranchiseDashboard = () => {
    const theme = useTheme();
    const responsive = getResponsiveStyles(theme);
    const [isMobile, setIsMobile] = useState(isMobileScreen(theme));
    const [activeUsersCount, setStateVariableForActiveUsers] = useState(0);
    const [inactiveUsersCount, setStateVariableForInactiveUsers] = useState(0);
    const [blockedUsersCount, setStateVariableForBlockedUsers] = useState(0);
    const [instockUsersCount, setStateVariableForInstockUsers] = useState(0);
    const [blacklistUsersCount, setStateVariableForBlacklistUsers] = useState(0);
    const [faultyUsersCount, setStateVariableForFaultyUsers] = useState(0);
    const [suspendUsersCount, setStateVariableForSuspendUsers] = useState(0);
    const [damagedUsersCount, setStateVariableForDamagedUsers] = useState(0);
    const [repairedUsersCount, setStateVariableForRepairedUsers] = useState(0);
    const [replacedUsersCount, setStateVariableForReplacedUsers] = useState(0);

    const [pendingSubscriptionsCount, setPendingSubscriptionsCount] = useState(0);
    const [activeSubscriptionsCount, setActiveSubscriptionsCount] = useState(0);
    const [inActiveSubscriptionsCount, setInActiveSubscriptionsCount] = useState(0);
    const [cancelledSubscriptionsCount, setCancelledSubscriptionsCount] = useState(0);
    const [expiredSubscriptionsCount, setExpiredSubscriptionsCount] = useState(0);

    const [todayRegistration, setTodayRegistration] = useState(0);
    const [todayDeActivatedCount, setTodayDeActivatedCount] = useState(0);
    const [todayReActivatedCount, setTodayReActivatedCount] = useState(0);

    const [channelsCount, setChannelsCount] = useState(0);
    const [franchiseCount, setFranchiseCount] = useState(0);
    const [operatorsCount, setOperatorsCount] = useState(0);
    const [packagesCount, setPackagesCount] = useState(0);

    const [allUsersCount, setStateVariableForAllUsers] = useState(0);
    const [packageRevenueData, setPackageRevenueData] = useState([]);
    const [usersCountData, setUsersCountData] = useState([]);
    const [filterDate, setFilterDate] = useState<Dayjs | null>(dayjs());

    const [onlyActiveUsersCount, setOnlyActiveUsersCount] = useState(0);
    const [onlyInActiveUsersCount, setOnlyInActiveUsersCount] = useState(0);
    const [onlyBlockedUsersCount, setOnlyBlockedUsersCount] = useState(0);

    //subcription expire count states
    const [todayExpireCount, setTodayExpireCount] = useState(0);
    const [sevenDaysExpireCount, setSevenDaysExpireCount] = useState(0);
    const [fourteenDaysExpireCount, setFourteenDaysExpireCount] = useState(0);
    
    const accountType = localStorage.getItem('accountType');

    const URL_PATH = authenticationService.getVendorFranchisePath();
    const { vendorId, franchiseId, companyId, operatorId } = authenticationService.getVendorFranchiseIds();
    const { selectedLCOId, selectedLCOName, selectedLCOFranchiseId } = authenticationService.getSelectedLCO();
    const navigate = useNavigate();
    
    //console.log(URL_PATH)

    //subcription expire count function
    const fetchAllExpireCounts = async () => {
        try {
            const buildParams = (days) => ({
                days,
                ...(accountType !== 'DISTRIBUTOR' && { selectedLCOId })
            });

            const baseUrl = `${process.env.REACT_APP_BASE_API_URL}/usersubscription/vendor/${vendorId}/franchise/${franchiseId}/expiring-soon`;

            const [todayRes, sevenRes, fourteenRes] = await Promise.all([
                get(baseUrl, { params: buildParams(1) }),
                get(baseUrl, { params: buildParams(7) }),
                get(baseUrl, { params: buildParams(14) })
            ]);

            setTodayExpireCount(todayRes?.data?.totalExpiring || 0);
            setSevenDaysExpireCount(sevenRes?.data?.totalExpiring || 0);
            setFourteenDaysExpireCount(fourteenRes?.data?.totalExpiring || 0);

        } catch (error) {
            console.error('Error fetching expire counts:', error);
        }
    };

    useEffect(() => {
        fetchAllExpireCounts();
        // let loggedInData = null;
        // if(accountType === 'DISTRIBUTOR') {
        //   loggedInData = JSON.parse(localStorage.getItem("selectedLCO"));
        //   console.log("DISTRIBUTOR::"+loggedInData?.id)
        // } else if(accountType === 'LCO') {
        //   loggedInData = JSON.parse(localStorage.getItem("operatorData"));
        //   console.log("LCO ID::"+loggedInData?.id)
        // }
        // setSelectedOperatorId(loggedInData?.id)
    }, []); 

    const fetchDashboardSummaryData = async () => {
        try {
            let params = {};
            if(accountType !== 'DISTRIBUTOR') {
                params['operatorId'] = selectedLCOId;
            }
            const date = dayjs(filterDate).format('YYYY-MM-DD HH:mm:ss');
            const data = await get(`${process.env.REACT_APP_BASE_API_URL}/api/dashboard/vendor/${vendorId}/franchise/${franchiseId}/getDashboardSummary`, {params: params});
       
            data?.userData.map(usr => {
                switch (usr.status) {
                    case "ACTIVE":
                        setOnlyActiveUsersCount(usr.count);
                        break;
                    case "INACTIVE":
                        setOnlyInActiveUsersCount(usr.count);
                        break;
                     case "BLACKLISTED":
                        setOnlyBlockedUsersCount(usr.count);
                        break;
                        
                }
            })
         
            const subscriptionData = data?.subscriptionData;

            setChannelsCount(data?.channelsCount);
            setFranchiseCount(data?.franchiseCount);
            setOperatorsCount(data?.operatorsCount);
            setPackagesCount(data?.packagesCount);

            const registrationDetails = data?.userRegistrationCountDetails;

            setTodayRegistration(registrationDetails?.registeredCount || 0);
            setTodayDeActivatedCount(registrationDetails?.deActivatedCount || 0);
            setTodayReActivatedCount(registrationDetails?.reActivatedCount || 0);

            subscriptionData.map(sub => {
                switch(sub.subscriptionPlan) {
                    case "PENDING":
                        setPendingSubscriptionsCount(sub.count);
                        break;
                    case "ACTIVE":
                        setActiveSubscriptionsCount(sub.count);
                        break;
                    case "INACTIVE":
                        setInActiveSubscriptionsCount(sub.count);
                        break;
                    case "CANCELED":
                        setCancelledSubscriptionsCount(sub.count);
                        break;
                    case "EXPIRED":
                        setExpiredSubscriptionsCount(sub.count);
                        break;
                }
            })
        } catch (error) {
            console.error('Error fetching users count: ', error);
        }
    };

    const fetchUserCountSummary = async () => {
        try {
            const date = dayjs(filterDate).format('YYYY-MM-DD HH:mm:ss');
            const data = await get(`${process.env.REACT_APP_BASE_API_URL}/api/dashboard/vendor/${vendorId}/franchise/${franchiseId}/getUserLogReport?filterDate=${date}`);
            
            console.log('datacount',data)
            // Update all user status counts
            setActiveUsersCount(data.activeUsers || 0);
            setInactiveUsersCount(data.inActiveUsers || 0);
            setDamagedUsersCount(data.damagedUsers || 0);
            setRepairedUsersCount(data.repairedUsers || 0);
            setReplacedUsersCount(data.replacedUsers || 0);
            //setBlockedUsersCount(data.blockedUsers || 0);
            setInstockUsersCount(data.instockUsers || 0);
            setBlacklistUsersCount(data.blacllisted  || 0);
            setFaultyUsersCount(data.faultyUsers || 0);
            setSuspendUsersCount(data.suspendUsers || 0);
        } catch (error) {
            console.error('Error fetching users count: ', error);
        }
    };

    const handleDownloadReport = async () => {
        try {
            const excelData = [
                { Metric: 'Active Users', Count: activeUsersCount },
                { Metric: 'Inactive Users', Count: inactiveUsersCount },
                { Metric: 'Damaged Users', Count: damagedUsersCount },
                { Metric: 'Repaired Users', Count: repairedUsersCount },
                { Metric: 'Replaced Users', Count: replacedUsersCount },
                //{ Metric: 'Blocked Users', Count: blockedUsersCount },
                { Metric: 'In Stock Users', Count: instockUsersCount },
                { Metric: 'Blacklist Users', Count: blacklistUsersCount },
                { Metric: 'Faulty Users', Count: faultyUsersCount },
                { Metric: 'Suspended Users', Count: suspendUsersCount },
                { Metric: 'Total Users', Count: (activeUsersCount + inactiveUsersCount + blockedUsersCount + instockUsersCount + blacklistUsersCount + faultyUsersCount + suspendUsersCount) }
            ];
            
            const ws = XLSX.utils.json_to_sheet(excelData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "UserCountSummary");
            
            XLSX.writeFile(wb, `UserCountSummary_${new Date().toISOString().split('T')[0]}.xlsx`);
            
        } catch (error) {
            console.error('Error downloading report:', error);
        }
    };

    // Fetch package revenue data
    const fetchPackageRevenueData = async () => {
        try {
            const response = await get(`${process.env.REACT_APP_BASE_API_URL}/api/dashboard/vendor/${vendorId}/franchise/${franchiseId}/packages-summary`);
            const transformedData = transformPackageData(response.data);
            setPackageRevenueData(transformedData);
        } catch (error) {
            console.error('Error fetching package price data:', error);
        }
    };

    // Transform API data to match the chart format
    const transformPackageData = (apiData) => {
        // Group data by year
        const groupedByYear = apiData.reduce((acc, item) => {
            if (!acc[item.year]) {
                acc[item.year] = { year: item.year.toString() };
            }
            acc[item.year][item.packageName.toLowerCase()] = item.totalAmount;
            return acc;
        }, {});

        // Convert to array format for the chart
        return Object.values(groupedByYear);
    };

    // Get unique package names for chart keys
   const getPackageKeys = (): string[] => {
    const keys = new Set<string>();
    packageRevenueData.forEach(item => {
        Object.keys(item).forEach(key => {
            if (key !== 'year') {
                keys.add(key);
            }
        });
    });
    return Array.from(keys);
};

    const setActiveUsersCount = (data) => {
        setStateVariableForActiveUsers(data);
    };

    const setInactiveUsersCount = (data) => {
        setStateVariableForInactiveUsers(data);
    };

    const setBlockedUsersCount = (data) => {
        setStateVariableForBlockedUsers(data);
    }

    const setInstockUsersCount = (data) => {
        setStateVariableForInstockUsers(data);
    }

    const setBlacklistUsersCount = (data) => {
        setStateVariableForBlacklistUsers(data);
    }

    const setFaultyUsersCount = (data) => {
        setStateVariableForFaultyUsers(data);
    }

    const setSuspendUsersCount = (data) => {
        setStateVariableForSuspendUsers(data);
    }

    const setDamagedUsersCount = (data) => {
        setStateVariableForDamagedUsers(data);
    }
    const setRepairedUsersCount = (data) => {
        setStateVariableForRepairedUsers(data);
    }
    const setReplacedUsersCount = (data) => {
        setStateVariableForReplacedUsers(data);
    }

    // Function to navigate to User Log
    const navigateToUserLog = () => {
        try {
            navigate('/ottreports/UserDetailLogReport');
        } catch (error) {
            console.error('Navigation failed:', error);
            window.open('/ottreports/UserDetailLogReport', '_blank');
        }
    }

    useEffect(() => {
        fetchUserCountSummary();
        fetchPackageRevenueData();
        fetchDashboardSummaryData();
    }, [filterDate]);

    
    
    // Updated pie chart data with ALL user statuses (including zero values)
    const pieChartData = [
        {
            "id": "Active Users",
            "label": "Active Users",
            "value": activeUsersCount,
            "color": "hsl(120, 70%, 50%)"
        },
        {
            "id": "InActive Users",
            "label": "Inactive Users",
            "value": inactiveUsersCount,
            "color": "hsl(30, 70%, 50%)"
        },
        {
            "id": "In Stock Users",
            "label": "In Stock",
            "value": instockUsersCount,
            "color": "hsl(210, 70%, 50%)"
        },
        {
            "id": "Damaged Users",
            "label": "Damaged",
            "value": damagedUsersCount,
            "color": "hsl(180, 70%, 50%)"
        },
        {
            "id": "Repaired Users",
            "label": "Repaired",
            "value": repairedUsersCount,
            "color": "hsl(180, 70%, 50%)"
        },
        {
            "id": "Replaced Users",
            "label": "Replaced",
            "value": replacedUsersCount,
            "color": "hsl(180, 70%, 50%)"
        },
        {
            "id": "Blocked Users",
            "label": "Blocked Users",
            "value": blockedUsersCount,
            "color": "hsl(0, 70%, 50%)"
        },
        {
            "id": "Blacklist Users",
            "label": "Blacklist",
            "value": blacklistUsersCount,
            "color": "hsl(300, 70%, 50%)"
        },
        {
            "id": "Faulty Users",
            "label": "Faulty",
            "value": faultyUsersCount,
            "color": "hsl(60, 70%, 50%)"
        },
        {
            "id": "Suspended Users",
            "label": "Suspended",
            "value": suspendUsersCount,
            "color": "hsl(180, 70%, 50%)"
        },
    ];

const summaryTiles = [
  {
    title: 'Total Users',
    value:  onlyActiveUsersCount +
      onlyInActiveUsersCount  ,
    icon: <GroupsIcon />,
    color: 'primary',
    onClick: () => navigate(`/ottUserPanle/userpanel`)
  },
  {
    title: 'Active Users',
    value: onlyActiveUsersCount,
    icon: <CheckCircleIcon />,
    color: 'success',
    onClick: () => navigate(`/ottUserPanle/userpanel/Active`)
  },
  {
    title: 'Inactive Users',
    value: onlyInActiveUsersCount,
    icon: <PauseCircleIcon />,
    color: 'warning',
    onClick: () => navigate(`/ottUserPanle/userpanel/InActive`)
  },
  {
    title: 'Blocked Users',
    value: onlyBlockedUsersCount,
    icon: <PauseCircleIcon />,
    color: 'warning',
    onClick: () => navigate(`/ottusers/BlockListedUsers`)
  }
];

const subscriptionSummaryTiles = [
  {
    title: 'Total Subscriptions',
    value: pendingSubscriptionsCount +
      activeSubscriptionsCount +
      inActiveSubscriptionsCount +
      
      cancelledSubscriptionsCount +
      expiredSubscriptionsCount,
    icon: <SubscriptionsIcon />,
    color: 'primary',
    onClick: () => navigate(`/ottsubscriptions/usersubscriptions`)
  },
  {
    title: 'Active',
    value: activeSubscriptionsCount,
    icon: <VerifiedIcon />,
    color: 'success',
    onClick: () => navigate(`/ottsubscriptions/usersubscriptions/ACTIVE`)
  },
  {
    title: 'Inactive',
    value: inActiveSubscriptionsCount,
    icon: <PauseCircleIcon />,
    color: 'info',
    onClick: () => navigate(`/ottsubscriptions/usersubscriptions/INACTIVE`)
  },
  {
    title: 'Canceled',
    value: cancelledSubscriptionsCount,
    icon: <CancelIcon />,
    color: 'error',
    onClick: () => navigate(`/ottsubscriptions/usersubscriptions/CANCELED`)
  },
  {
    title: 'Expired',
    value: expiredSubscriptionsCount,
    icon: <EventBusyIcon />,
    color: 'secondary',
    onClick: () => navigate(`/ottsubscriptions/usersubscriptions/EXPIRED`)
  }
];

const miscellaneousSummaryData = [
  {
    title: 'Channels Count',
    value: channelsCount,
    icon: <LiveTvIcon />,
    color: 'primary'
  },
  {
    title: 'Packages Count',
    value: packagesCount,
    icon: <InventoryIcon />,
    color: 'info'
  },
  {
    title: 'Franchise Count',
    value: franchiseCount,
    icon: <StoreMallDirectoryIcon />,
    color: 'error'
  },
  {
    title: 'Operators Count',
    value: operatorsCount,
    icon: <SupervisorAccountIcon />,
    color: 'success'
  }
];

const subcrbersexpiredata = [
    {
        title: 'Expiring Today',
        value: todayExpireCount || 0,
        icon: <HourglassBottomIcon />,
        color: 'error',
        onClick: () =>
            navigate('/ottusers/ExpiredSubcriptionList', {
                state: { filter: 'expiringSoon', days: 1 }
            })
    },
    {
        title: 'Expiring in 7 Days',
        value: sevenDaysExpireCount || 0,
        icon: <HourglassBottomIcon />,
        color: 'warning',
        onClick: () =>
            navigate('/ottusers/ExpiredSubcriptionList', {
                state: { filter: 'expiringSoon', days: 7 }
            })
    },
    {
        title: 'Expiring in 14 Days',
        value: fourteenDaysExpireCount || 0,
        icon: <HourglassBottomIcon />,
        color: 'info',
        onClick: () =>
            navigate('/ottusers/ExpiredSubcriptionList', {
                state: { filter: 'expiringSoon', days: 14 }
            })
    }
];

const todayUserStats = [
  {
    title: 'Today Registered',
    value: todayRegistration,
    icon: <GroupsIcon />,
    color: 'success',
    onClick: () =>  navigate(`/ottusers/SubscribeRegistrationStatus/ATCIVATED`)
  },
  {
    title: 'Today Deactivated',
    value: todayDeActivatedCount,
    icon: <BlockIcon />,
    color: 'error',
    onClick: () =>  navigate(`/ottusers/SubscribeRegistrationStatus/DE_ATCIVATED`)
  },
  {
    title: 'Today Reactivated',
    value: todayReActivatedCount,
    icon: <CheckCircleIcon />,
    color: 'info',
    onClick: () =>  navigate(`/ottusers/SubscribeRegistrationStatus/RE_ATCIVATED`)
  }
];

    return (
  <div style={{ padding: isMobile ? '10px' : '20px' }}>

    {/* ================= USER STATS ================= */}
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          fontWeight: 'bold',
          color: theme.palette.primary.main,
          borderBottom: `2px solid ${theme.palette.primary.main}`,
          pb: 1
        }}
      >
        User Stats
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' }, // 🔥 mobile fix
          gap: 1
        }}
      >
        {summaryTiles.map((tile, index) => (
          <Box key={index} sx={{ flex: 1 }}>
            <StatCard {...tile} />
          </Box>
        ))}
      </Box>
    </Box>

        {/* Today USER STATS */}
<Box sx={{ mb: 3 }}>
  <Typography
    variant="h5"
    sx={{
      mb: 2,
      borderBottom: `2px solid ${theme.palette.primary.main}`,
      paddingBottom: '8px'
    }}
  >
    Today User Stats
  </Typography>

  <Box sx={responsive.gridAutoFit}>
    {todayUserStats.map((tile, index) => (
      <Box key={index} sx={responsive.cardWrapper}>
        <StatCard {...tile} />
      </Box>
    ))}
  </Box>
</Box>

    {/* ================= SUBSCRIPTION ================= */}
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          fontWeight: 'bold',
          color: theme.palette.secondary.main,
          borderBottom: `2px solid ${theme.palette.secondary.main}`,
          pb: 1
        }}
      >
        Subscription Stats
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1
        }}
      >
        {subscriptionSummaryTiles.map((tile, index) => (
          <Box key={index} sx={{ flex: 1 }}>
            <StatCard {...tile} />
          </Box>
        ))}
      </Box>
    </Box>

    {/* ================= EXPIRY ================= */}
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          fontWeight: 'bold',
          color: theme.palette.secondary.main,
          borderBottom: `2px solid ${theme.palette.secondary.main}`,
          pb: 1
        }}
      >
        Subscription Expiry Stats
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1
        }}
      >
        {subcrbersexpiredata.map((tile, index) => (
          <Box key={index} sx={{ flex: 1 }}>
            <StatCard {...tile} />
          </Box>
        ))}
      </Box>
    </Box>

    {/* ================= CHARTS ================= */}
    {accountType === 'DISTRIBUTOR' && (
      <Grid container spacing={2}>

        {/* ================= PIE CHART ================= */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              border: `1px solid ${theme.palette.divider}`
            }}
          >

            {/* HEADER (🔥 MOBILE FIXED) */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'flex-start', sm: 'center' },
                justifyContent: 'space-between',
                gap: 1,
                px: 2,
                py: 1.5
              }}
            >
              <Typography fontWeight={600}>
                User Status By STB Device
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: 1,
                  width: { xs: '100%', sm: 'auto' }
                }}
              >

                {/* DATE */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Date"
                    value={filterDate}
                    onChange={(newValue) => setFilterDate(newValue)}
                    slotProps={{ textField: { size: 'small' } }}
                    sx={{ width: { xs: '100%', sm: 150 } }}
                    format="YYYY-MM-DD"
                  />
                </LocalizationProvider>

                {/* BUTTONS */}
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={navigateToUserLog}
                  >
                    List
                  </Button>

                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleDownloadReport}
                  >
                    <DownloadIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </Box>

            <Divider />

            {/* PIE */}
            <CardContent
              sx={{
                height: isMobile ? 260 : 300,
                p: 0,
                background: '#fff'
              }}
            >
              <ResponsivePie
                data={pieChartData}
                margin={{ top: 30, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.4}
                padAngle={1}
                cornerRadius={3}
                activeOuterRadiusOffset={6}
                borderWidth={1}
                colors={(d) => d.data.color}
                enableArcLabels={false}
              />
            </CardContent>
          </Card>
        </Grid>

        {/* ================= BAR CHART ================= */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              border: `1px solid ${theme.palette.divider}`
            }}
          >

            {/* HEADER */}
            <Box sx={{ px: 2, py: 1.5 }}>
              <Typography fontWeight={600}>
                Package Revenue by Year
              </Typography>
            </Box>

            <Divider />

            {/* BAR */}
            <CardContent
              sx={{
                height: isMobile ? 260 : 300,
                background: '#fff'
              }}
            >
              {packageRevenueData.length > 0 ? (
                <ResponsiveBar
                  data={packageRevenueData}
                  keys={getPackageKeys()}
                  indexBy="year"
                  margin={{ top: 30, right: 80, bottom: 40, left: 50 }}
                  padding={0.3}
                  colors={{ scheme: 'category10' }}
                />
              ) : (
                <Typography align="center" sx={{ mt: 6 }}>
                  Loading...
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>

      </Grid>
    )}
  </div>
);
}

export default FranchiseDashboard;